<template>
    <div>
        <div class="row pt-2" :class="{'bg-light-light': key % 2 == 0}" v-for="(item, key) in items" :key="key">
            <label class="label label-primary">{{ key+1 }}</label>
            <br/>
            <div class="col-md-12 pb-2" v-for="(detail, detailKey) in item.template_report_ikt_details" :key="detailKey">
                <div class="card">
                    <div class="card-body p-4">
                        <label class="label label-primary">{{key+1}}.{{ detailKey+1 }}</label>
                        <br/>
                        <div class="row">
                            <div class="form-group col-md-5">
                                <label>Indikator Kinerja *</label>
                                <select
                                    :id="`template_form_data_detail_id${key}_${detailKey}`"
                                    :name="`template_form_data_detail_id[${key}][${detailKey}]`"
                                    class="form-control indicator"
                                    style="width:100%"
                                    v-model="detail.template_form_data_detail_id"
                                    v-select="detail.template_form_data_detail_id"
                                    @change="onSelectIndicator(key, detailKey, detail.template_form_data_detail_id)">
                                </select>
                                <span class="form-text text-muted">Data sesuai dengan input pelaporan data</span>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-group">
                                    <label>Standar *</label>
                                    <div class="input-group">
                                        <div class="input-group-append"><span class="input-group-text">S</span></div>
                                        <input type="number" :name="`standard[${key}][${detailKey}]`" class="form-control" placeholder="Eg: 15" v-model="detail.standard" />
                                        <div class="input-group-append"><span class="input-group-text">%</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-group">
                                    <label>Target *</label>
                                    <div class="input-group">
                                        <div class="input-group-append"><span class="input-group-text">T</span></div>
                                        <input type="number" :name="`target[${key}][${detailKey}]`" class="form-control" placeholder="Eg: 20" v-model="detail.target" />
                                        <div class="input-group-append"><span class="input-group-text">%</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-group">
                                    <label>Urutan Form</label>
                                    <div class="input-group">
                                        <input type="number" :name="`order[${key}][${detailKey}]`" class="form-control" placeholder="Eg: 20" v-model="detail.order" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1 d-flex justify-content-end mt-8">
                                <button @click="removePart(key, detailKey)" type="button" class="btn btn-light-danger btn-sm btn-icon"><i class="la la-times"></i></button>
                            </div>
                        </div>
                        <div class="row">

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 p-4 d-flex justify-content-center">
                <button type="button" @click="addNewPart(key)" class="btn btn-info"><i class="la la-plus"></i>&nbsp;&nbsp;Tambah Sub Bagian</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TemplateReportIkiForm',
        props: {
            save: Number,
            year: [String, Number],
            initialItems: Array
        },
        computed: {
        },
        data() {
            return {
                items: [],
            }
        },
        watch: {
            save(val) {
                this.$emit('items', this.items)
            }
        },
        mounted() {
            if(this.initialItems) {
                this.items = this.initialItems
                setTimeout(() => {
                    this.loadIndicators()
                    this.items.map((item, key) => {
                        item.template_report_ikt_details.map((detail, detailKey) => {
                            $(`#template_form_data_detail_id${key}_${detailKey}`)
                                .empty()
                                .append(`<option value="${detail.template_form_data_detail_id}">${detail.template_form_data_detail.unit_with_indicator_name}</option>`)
                                .val(detail.template_form_data_detail_id)
                                .trigger('change')
                        })
                    })
                }, 300)
            }
            if (this.items.length <= 0) {
                this.addNew()
            }
        },
        methods: {
            removePart(key, detailKey) {
                this.items[key].template_report_ikt_details.splice(detailKey, 1)
            },
            removePartDetail(key, detailKey, formulaKey) {
                this.items[key].template_report_ikt_details[detailKey].details.splice(formulaKey, 1)
            },
            addNewPart(key) {
                this.items[key].template_report_ikt_details.push({
                    key: Math.random(4),
                    template_form_data_detail_id: null,
                    indicator_id: null,
                    report_indicator_labels: [],
                    standard: null,
                    target: null,
                    order: null,
                })
                setTimeout(() => {
                    this.loadIndicators()
                }, 300)
            },
            addNew() {
                this.items.push({
                    key: Math.random(4),
                    name: null,
                    template_report_ikt_details: [
                        {
                            key: Math.random(4),
                            template_form_data_detail_id: null,
                            indicator_id: null,
                            report_indicator_labels: [],
                            standard: null,
                            target: null,
                            order: null,
                        }
                    ]
                })
                setTimeout(() => {
                    this.loadIndicators()
                }, 300)
            },
            loadIndicators() {
                const app = this
                $('.indicator').select2({
                    placeholder: '-- Pilih salah satu --',
                    width: 'resolve',
                    ajax: {
                        url: '/ajax/dropdown-indicators-from-template',
                        dataType: "json",
                        type: "GET",
                        data: function (params) {
                            return {
                                search: params.term,
                                year: app.year
                            }
                        },
                        processResults: function (data, page) {
                            return {
                                results: data
                            };
                        }
                    }
                })
            },
            onSelectIndicator(key, detailKey, val) {
                this.items[key].template_report_ikt_details[detailKey].template_form_data_detail_id = val
                const params = {
                    year:this.year,
                    template_form_data_detail_id: val
                }
                axios.get('/ajax/get-template-indicator-labels', {
                    params
                }).then(({ data }) => {
                    const respData = data.data
                    this.items[key]
                        .template_report_ikt_details[detailKey]
                        .indicator_id = respData.indicator_id
                    this.items[key]
                        .template_report_ikt_details[detailKey]
                        .report_indicator_labels = respData.report_indicator_labels
                })
            }
        }
    }
</script>
